import { useState, useEffect } from "react";
import SearchIcon from "assets/icons/fi-rr-search.svg";
import ExcelIcon from "assets/icons/xlsx-file-format-extension-1.svg";
import "antd/dist/antd.css";
import styles from "./style.module.scss";
import "moment/locale/tr";
import locale from "antd/es/date-picker/locale/tr_TR";
import * as XLSX from "xlsx";
import { DatePicker } from "antd";
import { MonthlyIndexModelResponse } from "types";
import axios from "axios";
import { useParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import NextIcon from "assets/icons/pagination-next.svg";
import PrevIcon from "assets/icons/pagination-prev.svg";
import "../../../pages/sayacVerileri/paginate.css";
import LoaderSpinner from "../../UI/LoaderSpinner/LoaderSpinner";
import { locationController } from "utils/locationhelper";
import AuthService from "../../../services/AuthService";
import { useKeycloak } from "@react-keycloak/web";

import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify'

const { RangePicker } = DatePicker;
const TesisatDetaylariAylikEndex = () => {
  const params = useParams<any>();
  const [showDetail, setShowDetail] = useState(false);
  const [yearValue, setYearValue] = useState(0);
  const [montlyIndexList, setMontlyIndexList] = useState<MonthlyIndexModelResponse | []>(null!); 
  const [pageCount, setPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(24);
  const [isLoading, setIsLoading] = useState(false);
  
  const { keycloak } = useKeycloak();
  const auth = new AuthService(keycloak);

  let companyId = locationController();



  const getMontlyIndex = async() => {
    setIsLoading(true);

    auth.axios(`/EndOfMonthIndex/GetEndOfMonthIndex`, null, {
      tesisatNo: params.id,
      companyId : companyId,
      pageSize: itemsPerPage,
      page: pageNumber,
      year: yearValue 
    })
    .then(response => {
      setIsLoading(false);
      if (response.data.success === true) {
        setMontlyIndexList(response.data.data.itemList);
        setPageCount(Math.ceil(response.data.data.totalCount / itemsPerPage));
      }
      else {
        if (response.data.message) {
          toast.error(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored",
          });
        }
      }

    }).catch(err => {
      setIsLoading(false);

      toast.error(err.response.data.message, {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
      });

    });
    
  }

  useEffect(() => {
    if(yearValue!==0)
      getMontlyIndex()
  }, [pageNumber]);

  // Invoke when user click to request another page.
  const handlePageClick = (event: any) => {
    setPageNumber(event.selected + 1);
   };

  const handleExportCustonExcell = () => {
    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet(montlyIndexList);
    XLSX.utils.book_append_sheet(wb, ws, "Excel");
    XLSX.writeFile(wb, "AySonuEndeks.xlsx");
  };

  return (
    <div>
      <ToastContainer/>
      <div className={styles.monthlyIndex}>
        <div className={styles.headerCard}>
          <div className={styles.card}>
            <div>Yıl</div>
            <div>
              <DatePicker
                placeholder={"Yıl Seçiniz"}
                suffixIcon={false}
                locale={locale}
                bordered={false}
                picker="year"
                onChange={(date:any) => {
                  setYearValue(date?.year())
                }}
              />
            </div>
            <img
              onClick={() => {
                getMontlyIndex();
              }}
              src={SearchIcon}
              alt=""
            />
          </div>
          <div
            onClick={() => {
              handleExportCustonExcell();
            }}
            className={styles.excel}
          >
            <img src={ExcelIcon} alt="" />
            <div>Excel'e aktar</div>
          </div>
        </div>
        <div className={styles.detailTable}>
          <div className={styles.tableHeader}>
            <div>Tarih</div>
            <div>Toplam Aktif</div>
            <div>T1 (Gündüz)</div>
            <div>T2 (Puant)</div>
            <div>T3 (Gece)</div>
            <div>Endüktif Reaktif Tüketim</div>
            <div>Kapasitif Reaktif Tüketim</div>
            <div>Demand Tüketim</div>
            <div>Toplam Üretim</div>
            <div>U1 (Gündüz)</div>
            <div>U2 (Puant)</div>
            <div>U3 (Gece)</div>
            <div>Endüktif Reaktif Üretim</div>
            <div>Kapasitif Reaktif Üretim</div>
            <div>Demand Üretim</div>
          </div>
          <div className={styles.hr}></div>
          {isLoading ? <LoaderSpinner /> : 
            montlyIndexList?.map((data, idx) => (
              <div key={idx}>
                <div className={styles.tableRow}>
                  <div>{data.tarih}</div>
                  <div>{data.toplamAktif}</div>
                  <div>{data.t1Gunduz}</div>
                  <div>{data.t2Puant}</div>
                  <div>{data.t3Gece}</div>
                  <div>{data.enduktifReaktifTuketim}</div>
                  <div>{data.kapasitifReaktifTuketim}</div>      
                  <div>{data.demand}</div>
                  <div>{data.toplamUretim}</div>
                  <div>{data.u1Gunduz}</div>
                  <div>{data.u2Puant}</div>
                  <div>{data.u3Gece}</div>
                  <div>{data.enduktifReaktifUretim}</div>
                  <div>{data.kapasitifReaktifUretim}</div>
                  <div>{data.demandUretim}</div>
                </div>
                <div className={styles.hr}></div>
              </div>
            )) 
          }
        </div>
        <div className="pagination-container">
          <ReactPaginate
            breakLabel="..."
            nextLabel={<img src={NextIcon} alt="icon" />}
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel={<img src={PrevIcon} alt="icon" />}
            className="pagination"
            activeClassName="pagination-active-item"
            containerClassName="pagination-container"
            pageClassName="pagination-item"
            previousClassName="pagination-item-previous"
            nextClassName="pagination-item-next"
            breakClassName="pagination-item-break"
          />
        </div>
      </div>
    </div>
  );
};

export default TesisatDetaylariAylikEndex;
